import React from 'react';
import type { Member } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-page-http/types';
import { USER_PRIVACY_STATUS_PRIVATE } from '@wix/communities-blog-client-common';
import { getIsMemberAreaInstalled } from '../../store/communities-context/communities-context-selectors';
import { getProfileUrlByUser } from '../../store/profile-urls/profile-urls-selectors';
import { useSelector, useActions } from '../runtime-context';
import SiteLink from './site-link';

type Props = React.PropsWithChildren<{
  user: Member | undefined;
  className?: string;
}>;

const ProfileLink: React.FC<Props> = ({ user, className, children }) => {
  const actions = useActions();
  const profileUrl = useSelector((state) => getProfileUrlByUser(state, user));
  const isMemberAreaActive = useSelector(getIsMemberAreaInstalled);
  const isNavigable =
    isMemberAreaActive && user?.privacyStatus !== USER_PRIVACY_STATUS_PRIVATE && profileUrl;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    actions.navigateToProfile(user?.siteMemberId, user?.slug);
  };

  if (isNavigable) {
    return (
      <SiteLink
        onClick={handleClick}
        data-hook="profile-link"
        href={profileUrl}
        className={className}
      >
        {children}
      </SiteLink>
    );
  }

  return (
    <span className={className} data-hook="profile-link">
      {children}
    </span>
  );
};

export default ProfileLink;
